import { Outlet, useParams } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { AvailableModules } from 'generated/featureDefinitions'
import { FormsCustomizationRootPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import {
  CustomizationField,
  Identifiers,
  Resources,
} from 'modules/expenses/hooks/useExpensesCustomization'

export interface RouteContextParams {
  resource_type: keyof typeof Resources
  identifier?: keyof typeof Identifiers
  id?: string
}

export interface ModalContextParams {
  field: CustomizationField
}

const Container = () => {
  const { company } = useCurrentSession()
  const { resource_type, id, identifier } = useParams()
  const { data, loading } = useQuery(FormsCustomizationRootPageDocument, {
    variables: {
      companyId: company.id,
      moduleId: AvailableModules.expenses,
    },
  })
  const moduleAvailable =
    data?.companies.moduleAvailabilitiesConnection.nodes[0]?.available ?? false
  const canCustomizeSettings = data?.expenses?._policies.expenseCustomizeSettings.can ?? false

  const hasAccess = () => moduleAvailable && canCustomizeSettings

  if (loading) {
    return (
      <Box padding="s40" width="full" alignItems="center">
        <Spinner />
      </Box>
    )
  }
  return (
    <AuthorizeUser authorizeFn={() => hasAccess()}>
      <Outlet context={{ resource_type, id, identifier }} />
    </AuthorizeUser>
  )
}

export default Container
